import { z } from 'zod';
import { normalizeColombianPhone } from '../utils/phone';
/**
 * Inscripción de un prospecto como actor real dentro del modo demo.
 * El backend recibe `phone` ya normalizado a E.164 vía `normalizeColombianPhone`.
 * El campo `honeypot` debe venir vacío — si trae contenido, asumimos bot.
 */
export const DemoActorEnrollSchema = z.object({
    fullName: z.string().trim().min(3).max(120),
    email: z.string().email().max(160).trim().toLowerCase(),
    phone: z
        .string()
        .min(7, 'Teléfono inválido')
        .transform((raw) => normalizeColombianPhone(raw)),
    captchaToken: z.string().min(8),
    captchaAnswer: z.coerce.number().int(),
    honeypot: z.string().max(0).optional(),
});
/**
 * Body del endpoint POST /api/demo/reset.
 * `confirm` debe ser exactamente la cadena "RESET" para evitar disparos accidentales.
 */
export const DemoResetRequestSchema = z.object({
    preset: z.string().min(1).default('default'),
    confirm: z.literal('RESET'),
});
/** Respuesta de GET /api/demo/status. */
export const DemoStatusSchema = z.object({
    enabled: z.boolean(),
    preset: z.string().nullable(),
    eventId: z.string().uuid().nullable(),
    lastResetAt: z.string().datetime().nullable(),
    counts: z.object({
        seedAttendees: z.number().int(),
        actorAttendees: z.number().int(),
        talks: z.number().int(),
        sponsors: z.number().int(),
        scans: z.number().int(),
    }),
});
/**
 * Item devuelto por el endpoint de galería de QRs imprimible.
 * `source` se restringe a los orígenes válidos en demo (no CSV_IMPORT, FORM, etc.).
 */
export const DemoQrGalleryItemSchema = z.object({
    attendeeId: z.string().uuid(),
    fullName: z.string(),
    email: z.string(),
    qrToken: z.string().uuid(),
    shortCode: z.string().length(6),
    source: z.enum(['DEMO_SEED', 'DEMO_ACTOR']),
    hasAttended: z.boolean(),
    hasClaimedLunch: z.boolean(),
});
/** Respuesta paginada de GET /api/demo/qr-gallery. */
export const DemoQrGalleryResponseSchema = z.object({
    items: z.array(DemoQrGalleryItemSchema),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
});
/** Respuesta de GET /api/demo/captcha: reto aritmético con TTL. */
export const DemoCaptchaChallengeSchema = z.object({
    token: z.string(),
    question: z.string(),
    ttlSeconds: z.number().int(),
});
//# sourceMappingURL=demo.js.map